
const states = {
  OK: 'ok',
  ERROR: 'error',
  WARNING: 'warning',
  OFFLINE: 'offline',
  UNKNOWN: 'unknown'
}

export default states